import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Building2, Briefcase, TrendingUp, ShieldCheck, Clock, Users, Globe, CheckCircle2 } from 'lucide-react';
import { Button } from '../components/Button';
export function Home() {
  return <div className="flex flex-col" data-id="element-262">
      {/* Hero Section */}
      <section className="relative bg-slate-50 py-20 lg:py-32 overflow-hidden" data-id="element-263">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&q=80&w=2070')] bg-cover bg-center opacity-[0.03]" data-id="element-264"></div>
        <div className="container-custom relative z-10" data-id="element-265">
          <div className="max-w-3xl" data-id="element-266">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6" data-id="element-267">
              Corporate Services,{' '}
              <span className="text-blue-800" data-id="element-268">Commercial Brokerage</span> &
              Business Growth Support in Dubai
            </h1>
            <p className="text-xl text-gray-600 mb-10 leading-relaxed max-w-2xl" data-id="element-269">
              Structured, compliant, and execution-focused solutions for
              companies operating in the UAE and internationally.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-270">
              <Link to="/contact" data-id="element-271">
                <Button size="lg" data-id="element-272">Book a Consultation</Button>
              </Link>
              <Link to="/services" data-id="element-273">
                <Button variant="outline" size="lg" data-id="element-274">
                  Explore Services
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Section */}
      <section className="py-16 bg-white border-b border-gray-100" data-id="element-275">
        <div className="container-custom" data-id="element-276">
          <div className="text-center mb-12" data-id="element-277">
            <p className="text-sm font-semibold text-blue-800 uppercase tracking-widest mb-2" data-id="element-278">
              Why Choose Us
            </p>
            <h2 className="text-3xl font-bold text-gray-900" data-id="element-279">
              Built for founders, investors & operators
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-280">
            {[{
            icon: Building2,
            title: 'Dubai Free Zone Expertise',
            desc: 'Deep knowledge of IFZA, DSO, and UAE regulatory frameworks.'
          }, {
            icon: CheckCircle2,
            title: 'End-to-End Execution',
            desc: 'From initial setup to ongoing operational support.'
          }, {
            icon: ShieldCheck,
            title: 'Transparent Process',
            desc: 'Clear pricing, no hidden fees, and honest timelines.'
          }, {
            icon: Briefcase,
            title: 'Enterprise-Level Service',
            desc: 'Professional support designed for scaling businesses.'
          }].map((item, index) => <div key={index} className="p-6 bg-slate-50 rounded-lg border border-slate-100 hover:shadow-md transition-shadow" data-id="element-281">
                <item.icon className="h-10 w-10 text-blue-800 mb-4" data-id="element-282" />
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-283">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-284">{item.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="py-24 bg-gray-50" data-id="element-285">
        <div className="container-custom" data-id="element-286">
          <div className="flex flex-col md:flex-row justify-between items-end mb-12" data-id="element-287">
            <div className="max-w-2xl" data-id="element-288">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-289">
                Our Core Business Activities
              </h2>
              <p className="text-gray-600 text-lg" data-id="element-290">
                Comprehensive support for every stage of your business journey
                in the UAE.
              </p>
            </div>
            <Link to="/services" className="hidden md:block" data-id="element-291">
              <Button variant="outline" className="group" data-id="element-292">
                View All Services{' '}
                <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-293" />
              </Button>
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-294">
            {[{
            title: 'Corporate Services Provider',
            desc: 'Complete company structuring, documentation, and compliance support for Free Zone setups.',
            link: '/services#corporate',
            icon: Building2
          }, {
            title: 'Investment Management',
            desc: 'Strategic consulting, due diligence coordination, and post-investment operational support.',
            link: '/services#investment',
            icon: TrendingUp
          }, {
            title: 'Commercial Brokers',
            desc: 'Strategic introductions, deal facilitation, and negotiation support for commercial partnerships.',
            link: '/services#brokerage',
            icon: Users
          }].map((service, index) => <Link key={index} to={service.link} className="group bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-lg transition-all hover:-translate-y-1" data-id="element-295">
                <div className="h-12 w-12 bg-blue-50 rounded-lg flex items-center justify-center mb-6 group-hover:bg-blue-800 transition-colors" data-id="element-296">
                  <service.icon className="h-6 w-6 text-blue-800 group-hover:text-white transition-colors" data-id="element-297" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-298">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-6" data-id="element-299">{service.desc}</p>
                <span className="text-blue-800 font-medium flex items-center text-sm" data-id="element-300">
                  Learn more <ArrowRight className="ml-2 h-4 w-4" data-id="element-301" />
                </span>
              </Link>)}
          </div>

          <div className="mt-8 text-center md:hidden" data-id="element-302">
            <Link to="/services" data-id="element-303">
              <Button variant="outline" fullWidth data-id="element-304">
                View All Services
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="py-24 bg-white" data-id="element-305">
        <div className="container-custom" data-id="element-306">
          <div className="text-center mb-16" data-id="element-307">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-308">
              How We Work
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-309">
              A structured approach to ensure your business objectives are met
              efficiently.
            </p>
          </div>

          <div className="relative" data-id="element-310">
            {/* Connecting Line (Desktop) */}
            <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-gray-100 -translate-y-1/2 z-0" data-id="element-311"></div>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-8 relative z-10" data-id="element-312">
              {[{
              step: '01',
              title: 'Discovery',
              desc: 'We analyze your business needs and objectives.'
            }, {
              step: '02',
              title: 'Strategy',
              desc: 'We design the optimal structure and roadmap.'
            }, {
              step: '03',
              title: 'Execution',
              desc: 'We handle documentation, submissions, and setup.'
            }, {
              step: '04',
              title: 'Support',
              desc: 'Ongoing compliance and operational assistance.'
            }].map((item, index) => <div key={index} className="bg-white p-6 md:text-center" data-id="element-313">
                  <div className="w-12 h-12 bg-blue-800 text-white rounded-full flex items-center justify-center text-xl font-bold mb-4 md:mx-auto shadow-lg ring-4 ring-white" data-id="element-314">
                    {item.step}
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-315">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-316">{item.desc}</p>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* Why Brixen */}
      <section className="py-24 bg-slate-900 text-white overflow-hidden relative" data-id="element-317">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80&w=2069')] bg-cover bg-center opacity-10 mix-blend-overlay" data-id="element-318"></div>
        <div className="container-custom relative z-10" data-id="element-319">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-320">
            <div data-id="element-321">
              <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-322">
                Partner with a team that understands the landscape
              </h2>
              <p className="text-gray-300 text-lg mb-8" data-id="element-323">
                Navigating UAE business regulations can be complex. We simplify
                the process so you can focus on growth.
              </p>
              <ul className="space-y-4" data-id="element-324">
                {['Faster setup times with pre-validated checklists', 'Better corporate structuring for long-term growth', 'Reliable partner network for banking and legal needs', 'Ongoing compliance support to avoid penalties'].map((item, index) => <li key={index} className="flex items-start" data-id="element-325">
                    <CheckCircle2 className="h-6 w-6 text-blue-400 mr-3 shrink-0" data-id="element-326" />
                    <span className="text-gray-200" data-id="element-327">{item}</span>
                  </li>)}
              </ul>
              <div className="mt-10" data-id="element-328">
                <Link to="/about" data-id="element-329">
                  <Button variant="primary" className="bg-blue-600 hover:bg-blue-500 text-white border-none" data-id="element-330">
                    More About Us
                  </Button>
                </Link>
              </div>
            </div>
            <div className="bg-white/5 backdrop-blur-sm p-8 rounded-2xl border border-white/10" data-id="element-331">
              <div className="grid grid-cols-2 gap-6" data-id="element-332">
                <div className="p-4 bg-white/5 rounded-lg" data-id="element-333">
                  <div className="text-3xl font-bold text-blue-400 mb-1" data-id="element-334">
                    100+
                  </div>
                  <div className="text-sm text-gray-400" data-id="element-335">
                    Companies Supported
                  </div>
                </div>
                <div className="p-4 bg-white/5 rounded-lg" data-id="element-336">
                  <div className="text-3xl font-bold text-blue-400 mb-1" data-id="element-337">
                    24h
                  </div>
                  <div className="text-sm text-gray-400" data-id="element-338">Response Time</div>
                </div>
                <div className="p-4 bg-white/5 rounded-lg" data-id="element-339">
                  <div className="text-3xl font-bold text-blue-400 mb-1" data-id="element-340">3</div>
                  <div className="text-sm text-gray-400" data-id="element-341">Core Verticals</div>
                </div>
                <div className="p-4 bg-white/5 rounded-lg" data-id="element-342">
                  <div className="text-3xl font-bold text-blue-400 mb-1" data-id="element-343">
                    UAE
                  </div>
                  <div className="text-sm text-gray-400" data-id="element-344">Based & Focused</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-24 bg-gray-50" data-id="element-345">
        <div className="container-custom" data-id="element-346">
          <div className="text-center mb-16" data-id="element-347">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-348">
              What Our Clients Say
            </h2>
            <p className="text-gray-600" data-id="element-349">
              Trusted by entrepreneurs and businesses worldwide.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-350">
            {[{
            quote: 'Brixen helped us establish our Dubai presence in record time. Their process was clear and their team was always available.',
            author: 'Sarah Mitchell',
            role: 'Operations Director, UK'
          }, {
            quote: 'Professional, thorough, and genuinely helpful. They coordinated everything from documentation to office setup.',
            author: 'Ahmed Al-Rashid',
            role: 'Founder, Saudi Arabia'
          }, {
            quote: 'As a first-time entrepreneur in the UAE, I needed guidance I could trust. Brixen delivered exactly that.',
            author: 'Carlos Mendez',
            role: 'CEO, Spain'
          }, {
            quote: "Their commercial brokerage introductions opened doors we couldn't have accessed alone.",
            author: 'Priya Sharma',
            role: 'Managing Partner, India'
          }, {
            quote: 'Transparent pricing, no surprises, and excellent follow-through on every commitment.',
            author: 'Michael Chen',
            role: 'Director, Singapore'
          }, {
            quote: "The team's knowledge of Free Zone regulations saved us significant time and resources.",
            author: 'Elena Kowalski',
            role: 'CFO, Poland'
          }].map((testimonial, index) => <div key={index} className="bg-white p-8 rounded-xl shadow-sm border border-gray-100" data-id="element-351">
                <div className="flex text-blue-800 mb-4" data-id="element-352">
                  {[...Array(5)].map((_, i) => <svg key={i} className="w-4 h-4 fill-current" viewBox="0 0 20 20" data-id="element-353">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-354" />
                    </svg>)}
                </div>
                <p className="text-gray-700 mb-6 italic" data-id="element-355">
                  "{testimonial.quote}"
                </p>
                <div data-id="element-356">
                  <p className="font-bold text-gray-900" data-id="element-357">
                    {testimonial.author}
                  </p>
                  <p className="text-sm text-gray-500" data-id="element-358">{testimonial.role}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 bg-white" data-id="element-359">
        <div className="container-custom" data-id="element-360">
          <div className="bg-blue-900 rounded-2xl p-10 md:p-16 text-center text-white overflow-hidden relative" data-id="element-361">
            <div className="absolute top-0 right-0 -mr-20 -mt-20 w-64 h-64 bg-blue-700 rounded-full opacity-20 blur-3xl" data-id="element-362"></div>
            <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-64 h-64 bg-blue-500 rounded-full opacity-20 blur-3xl" data-id="element-363"></div>

            <div className="relative z-10 max-w-2xl mx-auto" data-id="element-364">
              <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-365">
                Ready to structure your next move in Dubai?
              </h2>
              <p className="text-blue-100 mb-10 text-lg" data-id="element-366">
                Book a consultation with our experts to discuss your business
                needs and get a tailored roadmap.
              </p>
              <Link to="/contact" data-id="element-367">
                <button className="inline-flex items-center justify-center rounded-md font-medium h-14 px-8 text-lg bg-white text-gray-900 hover:bg-gray-100 shadow-sm transition-colors" data-id="element-368">
                  Book a Consultation
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>;
}